import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchProductEntrys, selectProductEntryState } from "../redux/slices/productEntrySlice"
import { ApiStatus } from "../types/api/status"
import { ProductEntryAPI } from "../apis/ProductEntryAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"

export const useProductEntryStore = () => {
    const dispatch = useDispatch()
    const { productEntrys, productEntrySelected, status } = useSelector(selectProductEntryState)

    const getIntakeKart = async (data?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductEntryAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(onFetchProductEntrys(detail || []))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createProductEntry = async (data: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductEntryAPI.create(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "")
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    return {
        productEntrys,
        productEntrySelected,
        status,
        getIntakeKart,
        createProductEntry
    }
}